
import { ApiProperty } from "@nestjs/swagger";
import { FuleMeasuredInEnum, FuleTypeEnum, VehicleStatusenum, VehicleTypeEnum } from "./vehicle.enum";

export class VehicleDto {
    id: number
    vehicleType: VehicleTypeEnum;
    vehicleCapacity: number;
    vehicleName: string;
    markOrModel: string;
    markOrModelId: number;
    yearofManufacture: any | string;
    // upload: string;
    // status: string;
    registrationNumber: string;
    engineNumber: string;
    chassisNumber: string;
    fuleType: FuleTypeEnum;
    fuelMesureMentIn: FuleMeasuredInEnum;
    // trackUsageAs: string;
    secondaryOrAuxilaryMeter: string;
    vehicleStatus: VehicleStatusenum;
    insuranceNumber: string;
    // insuranceStartDate: string;
    insuranceExpiryDate: any | string;
    roadTexNo: string;
    roadTexLastDate: any | string;
    nationalPermitNo: string;
    nationalPermitLastDate: any | string;
    vehicleLastServicingDate :any | string;
    vehicleServicingDate :any | string;
    isActive: boolean;
    createdUser: string | null;
    createdAt: Date;
    updatedUser: string | null;
    updatedAt: Date;
    versionFlag: number;
    vendorId: number;


    constructor( id: number,
        vehicleType: VehicleTypeEnum,
        vehicleCapacity: number,
        vehicleName: string,
        markOrModel: string,
        markOrModelId: number,
        yearofManufacture: Date | string,
        // upload: string,
        // status: string,
        registrationNumber: string,
        // engineNumber: string,
        chassisNumber: string,
        fuleType: FuleTypeEnum,
        fuelMesureMentIn: FuleMeasuredInEnum,
        // trackUsageAs: string,
        secondaryOrAuxilaryMeter: string,
        vehicleStatus: VehicleStatusenum,

        insuranceNumber: string,
        // insuranceStartDate: string,
        insuranceExpiryDate: Date | string,
        roadTexNo: string,
        roadTexLastDate: Date | string,
        nationalPermitNo: string,
        nationalPermitLastDate: Date | string,
        vehicleLastServicingDate :Date | string,
        vehicleServicingDate :Date | string,
        isActive: boolean,
        createdUser: string | null,
        createdAt: Date,
        updatedUser: string | null,
        updatedAt: Date,
        versionFlag: number,
        vendorId: number
    ){
        this.id= id;
        this.vehicleType= vehicleType;
        this.vehicleCapacity = vehicleCapacity;
        this.vehicleName= vehicleName;
        this.markOrModel= markOrModel;
        this.yearofManufacture= yearofManufacture;
        this.markOrModelId= markOrModelId;
        // this.status= status;
        this.registrationNumber= registrationNumber;
        // this.engineNumber= engineNumber;
        this.chassisNumber= chassisNumber;
        this.fuleType= fuleType;
        this.fuelMesureMentIn= fuelMesureMentIn;
        // this.trackUsageAs= trackUsageAs;
        this.secondaryOrAuxilaryMeter= secondaryOrAuxilaryMeter;
        this.vehicleStatus = vehicleStatus;
        
        this.insuranceNumber= insuranceNumber;
        // this.insuranceStartDate= insuranceStartDate;
        this.insuranceExpiryDate= insuranceExpiryDate;
        this.roadTexNo= roadTexNo;
        this.roadTexLastDate= roadTexLastDate;
        this.nationalPermitNo= nationalPermitNo;
        this.nationalPermitLastDate= nationalPermitLastDate;
        this.vehicleServicingDate = vehicleServicingDate;
        this.vehicleLastServicingDate = vehicleLastServicingDate; 
        this.isActive= isActive;
        this.createdUser= createdUser;
        this.createdAt= createdAt;
        this.updatedUser= updatedUser;
        this.updatedAt= updatedAt;
        this.versionFlag= versionFlag;
        this.vendorId= vendorId;

    
        }
}